module.exports = __webpack_public_path__ + "img/30f5a818ffa0f791ccccb7b4769baf7e.png";